import { Header, Footer, PageHero, ReviewsBlock, EstimateForm } from "@/components/site";

export default function ReviewsPage() {
  return (
    <div className="bg-white text-slate-800">
      <Header />
      <PageHero overline="Testimonials" title="Reviews & Testimonials" subtitle="Rated 5.0 across 100+ Google reviews — see why homeowners across Aurora and the GTA trust Segal Aurora Painters." />
      <ReviewsBlock />
      <EstimateForm />
      <Footer />
    </div>
  );
}
